(function () {
  const selectors = {
    timerSettings: '[data-timer-settings]',
    days: '[data-days]',
    hours: '[data-hours]',
    minutes: '[data-minutes]',
    seconds: '[data-seconds]'
  };

  const classes = {
    active: 'active',
    hide: 'hide',
    complete: 'complete'
  };

  class CountdownTimer {
    constructor(container) {
      this.container = container;
      this.settings = JSON.parse(container.querySelector(selectors.timerSettings).innerHTML);
      this.daysEl = container.querySelector(selectors.days);
      this.hoursEl = container.querySelector(selectors.hours);
      this.minutesEl = container.querySelector(selectors.minutes);
      this.secondsEl = container.querySelector(selectors.seconds);
      this.init();
    }

    init() {
      const {
        year,
        month,
        day,
        hour,
        minute,
        shopTimezone,
        timeZoneSelection,
        hideTimerOnComplete
      } = this.settings;

      const timezoneString = timeZoneSelection === 'shop' ? ` GMT${shopTimezone}` : '';
      this.countDownDate = new Date(Date.parse(`${month} ${day}, ${year} ${hour}:${minute}${timezoneString}`)).getTime();
      this.timerInterval = setInterval(() => this.updateTimer(), 1000);
      this.updateTimer(); // Initial call
      this.container.classList.add(classes.active);
    }

    updateTimer() {
      requestAnimationFrame(() => {
        const now = new Date().getTime();
        const distance = this.countDownDate - now;

        if (distance < 0) {
          this.stopTimer();
        } else {
          this.displayTime(distance);
        }
      });
    }

    displayTime(distance) {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.daysEl.innerHTML = days;
      this.hoursEl.innerHTML = hours;
      this.minutesEl.innerHTML = minutes;
      this.secondsEl.innerHTML = seconds;
    }

    stopTimer() {
      clearInterval(this.timerInterval);
      this.daysEl.innerHTML = 0;
      this.hoursEl.innerHTML = 0;
      this.minutesEl.innerHTML = 0;
      this.secondsEl.innerHTML = 0;
      this.container.classList.add(classes.complete);
      if (this.settings.hideTimerOnComplete) {
        this.container.classList.add(classes.hide);
      }
    }

    destroy() {
      clearInterval(this.timerInterval);
    }
  }

  // Register component logic for multiple countdown sections based on `data-section-id`
  function registerCountdownBanners() {
    const containers = document.querySelectorAll('.countdown-banner');
    const countdownTimers = Array.from(containers).map(container => new CountdownTimer(container));
    return {
      unload() {
        countdownTimers.forEach(timer => timer.destroy());
      }
    };
  }

  // Ensure the function is exposed globally if needed
  window.registerCountdownBanners = registerCountdownBanners;
})();

document.addEventListener("DOMContentLoaded", (event) => {
  
  const countdownBanner = registerCountdownBanners();
  
  /* ATC button log out user redirection to login -- Start */
  if( document.querySelectorAll("[data-logged_out_user_button]").length > 0){
    document.querySelector("[data-logged_out_user_button]").addEventListener("click", function() {
      const dropdownCustomer = document.querySelector("#dropdown-customer");
      const dropdownUser = document.querySelector("[data-dropdown-user]");
      const clickEvent = new Event("click", {
        bubbles: true,
        cancelable: true,
      });
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      if (dropdownCustomer && dropdownCustomer.style.display !== 'block') {
        setTimeout(() => {
          dropdownUser.dispatchEvent(clickEvent);
        }, 1000);
      }
    });
    document.querySelector("#dropdown-customer");
  }
  /* ATC button log out user redirection to login -- End */


  /* Variant Selector - Start */  
  class variantSelector extends HTMLElement {  
    constructor() {
      super();
      this.productJson = JSON.parse(this.querySelector('#product_json').textContent);
      this.currentVariant = null;
    }
  
    connectedCallback() {
      this.addEventListeners(this);
      this.addDisabledClassToOosVariant();
    }

    addDisabledClassToOosVariant() {
      document.querySelector(".variant-out-of-stock input:checked").parentNode.querySelector("label").classList.add("disabled");
    }

    addEventListeners(variantSelector){
      window.variantSelector = variantSelector;
      variantSelector.querySelectorAll("input").forEach(el => {
        el.addEventListener("change", this.variantChanged.bind(this));
      })
      variantSelector.querySelectorAll("select").forEach(el => {
        el.addEventListener("change", this.variantChanged.bind(this));
      })
    }

    getCurrentVariant(variantoptionsString){
      for (let i = 0; i < this.productJson.variants.length; i++) {
        if (this.productJson.variants[i].title === variantoptionsString) {
            return this.productJson.variants[i];
        }
      }
    }

    variantChanged(inputVal) {
      let _this1 = this;
      let currOptionSelectedValue = inputVal.currentTarget.value
      let VariantString = null;
      _this1.querySelectorAll(".option-main").forEach(el => {
        if(el.dataset.option_style == "radio"){
          if(!VariantString){
            VariantString = el.querySelector("input:checked").value;
          }
          else{
            VariantString = VariantString + " / " + el.querySelector("input:checked").value;
          }
        }
        else{
          if(!VariantString){
            VariantString = el.querySelector("select").value;
          }
          else{
            VariantString = VariantString + " / " + el.querySelector("select").value;
          }
        }
      })
      
      this.currentVariant = this.getCurrentVariant(VariantString.trim())
      this.updateVaraiantDependencies(this.currentVariant);
      this.updateURLParameter("variant", this.currentVariant.id)
      this.updateVariantLabel(inputVal);
    }

    updateVariantLabel(inputVal) {
      inputVal.currentTarget.closest(".option-main").querySelector("[data-option-select]").innerHTML = inputVal.currentTarget.value;
    }
    
    updateVaraiantDependencies() {
      
      if(this.currentVariant){
        document.querySelector("[name='id']").value = this.currentVariant.id;
        document.querySelector(".product__price-and-ratings [data-price]").innerHTML = money_format.replace('', (this.currentVariant.price / 100).toFixed(2));
        document.querySelector("[data-product-sku]").innerHTML = "SKU: " + this.currentVariant.sku;
        if(this.currentVariant.available){
          document.querySelector(".product-form__controls-group--submit button").removeAttribute("disabled");
          document.querySelector(".product-form__controls-group--submit button [data-add-to-cart-text]").innerHTML = ( window.isUserLoggedIn ) ? "Add To Cart" : "SIGN IN FOR PRO PRICES";
          document.querySelector(".size-swatches label.disabled").classList.remove("disabled");
        }
        else{
          document.querySelector(".product-form__controls-group--submit button").setAttribute("disabled", "true");
          document.querySelector(".product-form__controls-group--submit button [data-add-to-cart-text]").innerHTML = "Sold out";
          document.querySelector(".size-swatches input:checked").parentNode.querySelector("label").classList.add("disabled");
        }
      }
      else{
        
      }
      
    }
    
    updateURLParameter(paramKey, paramValue) {
      let currentURL = window.location.href.split('#')[0];
      let urlObj = new URL(currentURL);    
      urlObj.searchParams.set(paramKey, paramValue);
      let newURL = urlObj.toString();
      history.pushState({ path: newURL }, '', newURL);
    }

    disconnectedCallback() {
      // console.log("Custom element removed from page.");
    }
  
    adoptedCallback() {
      // console.log("Custom element moved to new page.");
    }
  
    attributeChangedCallback(name, oldValue, newValue) {
      // console.log(`Attribute ${name} has changed.`);
    }
  }
  
  customElements.define("variant-selector", variantSelector);
  /* Variant Selector - End */  

  /* Variant Selector - Start */  
  class quantitySelector extends HTMLElement {
    constructor() {
      super();
      this.addEventListeners()
    }
  
    addEventListeners(){
      console.log(this, this.querySelectorAll("button"));
      this.querySelectorAll("button").forEach(el => {
        el.addEventListener("click", this.handleQuantityEvent.bind(this))
      })
    }

    handleQuantityEvent(e) {
      // console.log(e, e.currentTarget, e.currentTarget.hasAttribute("data-subtract-quantity"), e.currentTarget.hasAttribute("data-add-quantity"))
      let quantityInputEl = this.querySelector("input[data-quantity-input]")
      let previousValue = parseInt(quantityInputEl.value);
      
      if(e.currentTarget.hasAttribute("data-subtract-quantity")){
        if(previousValue > 1){
          quantityInputEl.value = parseInt(quantityInputEl.value) - 1;
        }
      }
      else if(e.currentTarget.hasAttribute("data-add-quantity")){
        quantityInputEl.value = parseInt(quantityInputEl.value) + 1;
      }
      else{
        // else Part
      }
      this.updateQuantityValue(quantityInputEl.value);
    }

    updateQuantityValue(qty) {
      document.querySelector("form [name='quantity']").value = qty;
    }
  }
  customElements.define("quantity-selector", quantitySelector);

  document.querySelectorAll("video").forEach(el => {
    el.closest(".accordion__inner").querySelector("button.accordion__label").addEventListener("click", function(e) {
      const video = e.currentTarget.closest(".accordion__inner").querySelector("video");
      setTimeout(function(){
        if(video.closest(".accordion__content").style.display == "block"){
          video.play();
        }
        else{
          video.pause();
        }
      }, 300)
    });
  });

});

$(document).on('click', '.header-bottom .search-mb .icon-search', function() {
  $(this).hide();
  $(".wrapper-header .search-mb .close-search").show();
  $(".wrapper-header .header-mb .search-form").addClass('active');
});

$(document).on('click', '.wrapper-header .search-mb .close-search', function() {
  $(this).hide();
  $(".header-bottom .search-mb .icon-search").show();
  $(".wrapper-header .header-mb .search-form").removeClass('active');
});

$(document).ready(function() {
  $('.steps-count__btn').click(function(e) {
    e.preventDefault();
    var target = $($(this).attr('href'));
    if (target.length) {
      var scrollTo = target.offset().top;
      $('html, body').animate({ scrollTop: scrollTo }, 800);
    }

    let stepOnetext = document.querySelector(".step_1_text");
    if(stepOnetext){
      stepOnetext.classList.add("hide-element");
    }
    let stepTwotexts = document.querySelectorAll(".step_2_text");
    stepTwotexts.forEach(function(element){
      if(element.classList.contains("hide-element")){
        element.classList.remove("hide-element");
      }
    });
    
  });
});

// document.addEventListener("DOMContentLoaded", function () {

//   function multiCartProductRemovehandler(keys) {
//     // Build the updates object with quantity 0 for each key
//     let updates = {};

//     keys.forEach(function (key) {
//       updates[key] = 0; // Set quantity to 0 to remove the item
//     });

//     fetch(window.Shopify.routes.root + 'cart/update.js', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({ updates }),
//     })
//     .then(response => response.json())
//     .then(data => {
//       console.log('Cart updated successfully:', data);
//       // location.reload(); // Optional: Reload page to reflect changes
//     })
//     .catch(error => {
//       console.error('Error:', error);
//     });
//   }

//   document.querySelectorAll(".custom-remove").forEach(function (element) {
//     element.addEventListener("click", function (e) {
//       e.preventDefault();
//       e.stopPropagation();

//       let dataTimeStamp = e.currentTarget.dataset.timestamp;
//       let cartRemovableItems = [];

//       if (dataTimeStamp) {
//         document.querySelectorAll(`[data-timestamp="${dataTimeStamp}"]`).forEach(function (ele) {
//           let dataKey = ele.dataset.key;
//           if (dataKey) {
//             cartRemovableItems.push(dataKey);
//           }
//         });

//         if (cartRemovableItems.length > 0) {
//           multiCartProductRemovehandler(cartRemovableItems);
//         }
//       }
//     });
//   });

// });

